import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["type", "size", "className", "margin", "color"];
import React from 'react';
import PropTypes from 'prop-types';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { addMarginClasses, marginPropTypes } from '../customPropTypes/spacing';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * @deprecated since 3.0.0. Use individual Icon React components instead.
 * Component will be removed in the next major release.
 */
function Icon(_ref) {
  var type = _ref.type,
    size = _ref.size,
    className = _ref.className,
    margin = _ref.margin,
    color = _ref.color,
    htmlProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_icon', "st_icon--".concat(size)];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addMarginClasses(margin, cssClasses);
  if (color) cssClasses.push("st_icon--color-".concat(color));
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: cssClasses.join(' ')
  }, htmlProps, {
    children: /*#__PURE__*/_jsx("use", {
      xlinkHref: "#icon-".concat(type)
    })
  }));
}
process.env.NODE_ENV !== "production" ? Icon.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg']),
  /** type of icon */
  type: PropTypes.string.isRequired,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for icon, if any */
  margin: marginPropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white'])
} : void 0;
Icon.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};
export default Icon;